var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCelular(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 28,
    viewBox: "0 0 17 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5697 0.0127273L2.41816 0C1.08149 0 0 1.14545 0 2.54545V25.4545C0 26.8545 1.08149 28 2.41816 28H14.5697C15.9064 28 17 26.8545 17 25.4545V2.54545C17 1.14545 15.9064 0.0127273 14.5697 0.0127273ZM14.5697 22.9091H2.41816V5.09091H14.5697V22.9091Z",
    fill: "#8C8E86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelular);
export default __webpack_public_path__ + "static/media/celular.c7f032cf665c0499fc6684d738fc9334.svg";
export { ForwardRef as ReactComponent };